import { useContext } from 'react'
import { observer } from 'mobx-react-lite'

import { Toast } from 'common/Toast/Toast'
import { CollabStateContext } from 'stores/CollabState'

export const StatusToast = observer(function StatusToast() {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { statusMessage } = useContext(CollabStateContext)!

  return <>{!!statusMessage && <Toast position="top">{statusMessage}</Toast>}</>
})
